import {ValidationErrors, NEW_STATUS_ID} from "./constants";
import {
    getEditDialogData
} from "./selectors";
import * as api from "./apiCalls"
import {setWorkflowStatusesList} from '../../entities/actions'
import {getWorkflowStatuses} from '../../entities/selectors'
import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../redux/utils'

export const loadData = () => dispatch => {
    dispatch(createActionObject(ActionTypes.LOAD_DATA))
    api.getPageData()
       .then(data => {
           dispatch(createActionObject(ActionTypes.LOAD_DATA_SUCCESS, data.idsOfUsedWorkflowStatuses))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
       .catch(({error}) => {
           dispatch(createActionObject(ActionTypes.LOAD_DATA_FAILURE, [error]))
       })
}

export const createOrEditWorkflowStatus = () => (dispatch, getState) => {
    const errors = validateName(
        getEditDialogData(getState()),
        Object.values(getWorkflowStatuses((getState()))),
    )
    if (errors.length > 0) {
        dispatch(createActionObject(ActionTypes.SET_ERRORS, errors))
        return
    }

    const isCreate = getEditDialogData(getState()).id === NEW_STATUS_ID
    if (isCreate) {
        dispatch(createWorkflowStatus())
    } else {
        dispatch(editWorkflowStatus())
    }
}

const createWorkflowStatus = () => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.CREATE_NEW_STATUS))
    api.addNewWorkflowStatus(getEditDialogData(getState()))
       .then(data => {
           dispatch(createActionObject(ActionTypes.CREATE_NEW_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
           dispatch(toggleDialogVisibility(false))
       })
       .catch(({error, data}) => {
           dispatch(createRequestErrorActionObject(ActionTypes.CREATE_NEW_STATUS_FAILURE, error, data))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
}

const editWorkflowStatus = () => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.EDIT_STATUS))
    const editDialogData = getEditDialogData(getState())
    api.updateWorkflowStatus(editDialogData)
       .then(data => {
           dispatch(createActionObject(ActionTypes.EDIT_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
           dispatch(toggleDialogVisibility(false))
       })
       .catch(({error, data}) => {
           dispatch(createRequestErrorActionObject(ActionTypes.EDIT_STATUS_FAILURE, error, data))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))

           // call after errors for correct handling
           if (error === ValidationErrors.STATUS_DELETED) {
               // need to close dialog
               dispatch(toggleDialogVisibility(false))
           }
       })
}

export const deleteWorkflowStatus = (id) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.DELETE_STATUS))
    api.deleteWorkflowStatus(id)
       .then(data => {
           dispatch(createActionObject(ActionTypes.DELETE_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
       .catch(({error, data}) => {
           dispatch(createRequestErrorActionObject(ActionTypes.DELETE_STATUS_FAILURE, error, data))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
}

export const changeWorkflowStatusPosition = ({id, newPosition}) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.CHANGE_STATUS_POSITION))
    api.updateWorkflowStatusPosition({id, newPosition})
       .then(data => {
           dispatch(createActionObject(ActionTypes.CHANGE_STATUS_POSITION_SUCCESS, data.idsOfUsedWorkflowStatuses))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
       .catch(({error, data}) => {
           dispatch(createRequestErrorActionObject(ActionTypes.CHANGE_STATUS_POSITION_FAILURE, error, data))
           dispatch(setWorkflowStatusesList(data.workflowStatuses))
       })
}

export const addNewStatusAction = (type) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.START_CREATE_STATUS, type))
    dispatch(toggleDialogVisibility(true))
}

export const startEditStatusAction = (id) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.START_EDIT_STATUS, getWorkflowStatuses(getState())[id]))
    dispatch(toggleDialogVisibility(true))
}

export const toggleDialogVisibility = createAction(ActionTypes.TOGGLE_DIALOG_VISIBILITY)

export const cancelEditOrCreateStatusAction = () => dispatch => {
    dispatch(createActionObject(ActionTypes.CANCEL_EDIT_OR_CREATE_STATUS))
    dispatch(toggleDialogVisibility(false))
}

export const updateEditingStatusColorIdAction = (colorId) => dispatch => {
    dispatch(createActionObject(ActionTypes.UPDATE_EDITING_STATUS, {colorId: colorId}))
}

export const updateEditingStatusNameAction = (name) => dispatch => {
    dispatch(createActionObject(ActionTypes.UPDATE_EDITING_STATUS, {name: name}))
    dispatch(createActionObject(ActionTypes.SET_ERRORS, []))
}

function validateName(editingStatusData, allWorkflowStatuses) {
    let errors = []
    const editingStatus = editingStatusData

    if (editingStatus.name === '') {
        errors.push(ValidationErrors.EMPTY_NAME_ERROR)
    }

    if (allWorkflowStatuses.find(s => s.name.toLowerCase() === editingStatus.name.toLowerCase() && s.id !== editingStatus.id)) {
        errors.push(ValidationErrors.DUPLICATE_NAME_ERROR)
    }
    return errors
}

function createRequestErrorActionObject(type, error, data) {
    return createActionObject(
        ActionTypes.DELETE_STATUS_FAILURE,
        {
            errors: [error],
            statusesInUseIds: data.idsOfUsedWorkflowStatuses,
        }
    )
}



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/actions.js